export const RESET = 'EXSBMEASURE_UPDATE_RESET'
export const SET_ERROR = 'EXSBMEASURE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBMEASURE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBMEASURE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBMEASURE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBMEASURE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBMEASURE_UPDATE_UPDATE_RETRIEVED'
